<template>
  <div class="col-md-12 client_orders_list">

    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <div class="select">
            <tree-select
                :options="type_list"
                :multiple="false"
                v-model="filter.type"
                :placeholder="translate('client_order.type')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <fg-input
                type="text"
                v-model="filter.search"
                :placeholder="translate('client_order.search')"
                :clearable="true"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select">
          <div class="select">
            <tree-select
                :options="status_list"
                :multiple="false"
                v-model="filter.status"
                :placeholder="translate('client_order.status')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <WrapDatePicker
                type="date"
                :placeholder="translate('client_order.period')"
                v-model="filter.date"
                :range="true"
                :confirm="true"
                value_type="YYYY-MM-DD"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select">
          <div class="select">
            <tree-select
                :options="client_list"
                :multiple="true"
                v-model="filter.client_ids"
                :placeholder="translate('client_order.client_name')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <tree-select
                :options="specification_list"
                :multiple="false"
                v-model="filter.client_order_spec_id"
                :placeholder="translate('client_order.specification')"
                :clearable="true"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select">
          <div class="select">
            <tree-select
                :options="article_list"
                :multiple="true"
                v-model="filter.device_skus"
                :placeholder="translate('client_order.article')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <tree-select
                :options="params_list"
                :multiple="true"
                v-model="additional_params"
                :placeholder="translate('client_order.additional_params')"
                :clearable="true"
                @input="change_input"
            />
          </div>
        </div>

        <div class="buttons">
          <span
              class="btn btn-warning btn-fill"
              @click.prevent="reset_filter"
          >
            <b>{{ translate('filter.reset') }}</b>
          </span>
          <span
              v-if="$store.getters.getPermissions.permissionGod === true"
              class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
              @click.prevent="add_client_order"
          >
            <b>{{ translate('client_order.to_add') }}</b>
          </span>
          <span
              v-if="$store.getters.getPermissions.permissionGod === true && number_checked > 0"
              class="btn btn-info btn-fill"
              @click.prevent="formation_orders"
          >
            <b>{{ translate('client_order.formation_orders') }}</b>
          </span>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div class="summary card" v-if="summary.length > 0">
        <p v-for="(sum, key) in summary" :key="key">
          <span>{{ translate("client_order.summary." + sum.name) }}:</span>
          <span v-html="sum.value" />
        </p>
      </div>
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" class="w50">
              <input type="checkbox" v-model="checkall" @change="checkAll">
              <span v-if="number_checked > 0">{{ number_checked }}</span>
            </th>
            <th
                class="pointer w50"
                @click="change_filter('id')"
                :class="{ selected: filter_type === 'id' }"
                scope="col"
            >
              {{ translate('client_order.id') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer w50"
                @click="change_filter('client_order_spec_id')"
                :class="{ selected: filter_type === 'client_order_spec_id' }"
                scope="col"
            >
              {{ translate('client_order.client_order_spec') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('date')"
                :class="{ selected: filter_type === 'date' }"
                scope="col"
            >
              {{ translate('client_order.date') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('utd_number')"
                :class="{ selected: filter_type === 'utd_number' }"
                scope="col"
            >
              {{ translate('client_order.utd_number') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('order_form')"
                :class="{ selected: filter_type === 'order_form' }"
                scope="col"
            >
              {{ translate('client_order.order_form') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('type')"
                :class="{ selected: filter_type === 'type' }"
                scope="col"
            >
              {{ translate('client_order.type') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer name"
                @click="change_filter('client_name')"
                :class="{ selected: filter_type === 'client_name' }"
                scope="col"
            >
              {{ translate('client_order.client') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer name"
                @click="change_filter('name')"
                :class="{ selected: filter_type === 'name' }"
                scope="col"
            >
              {{ translate('client_order.name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer name w12per"
                @click="change_filter('device_sku')"
                :class="{ selected: filter_type === 'device_sku' }"
                scope="col"
            >
              {{ translate('client_order.device_sku') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('device_count')"
                :class="{ selected: filter_type === 'device_count' }"
                scope="col"
            >
              {{ translate('client_order.device_count') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer name"
                @click="change_filter('equipment')"
                :class="{ selected: filter_type === 'equipment' }"
                scope="col"
            >
              {{ translate('client_order.equipment') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>

            <th
                class="pointer"
                @click="change_filter('customer_user_name')"
                :class="{ selected: filter_type === 'customer_user_name' }"
                scope="col"
            >
              {{ translate('client_order.customer_user_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('status')"
                :class="{ selected: filter_type === 'status' }"
                scope="col"
            >
              {{ translate('client_order.status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <ClientOrderListItem
              v-for="(client_order,key) in orders_list"
              :key="key"
              :client_order="client_order"
              @update_checked="update_checked"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ClientOrderListItem from "./Item/Index.vue";
import AddClientOrder from "./Modal/AddClientOrder.vue";
import FormationOrders from "./Modal/FormationOrders.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'ClientOrderList',
  components: {
    WrapDatePicker,
    ClientOrderListItem
  },
  data () {
    return {
      client_orders_list: [],
      client_orders_statuses: [],
      searched_client_orders: '',
      check_link: true,
      filter:{
        type: null,
        status: null,
        client_ids: [],
        date: [],
        customer_user_id: null,
        device_skus: [],
        search: "",
        not_send_client: null,
        only_send_client: null,
        client_order_spec_item_id: null,
        client_order_spec_id: null
      },
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      additional_params: [],
      checkall: false
    }
  },

  computed:{
    number_checked(){
      return this.client_orders_list.reduce((count, item) => count + (item.checked === true ? 1 : 0), 0)
    },
    params_list(){
      return [
        { id: "not_send_client", label: this.translate("client_order.not_send_client")},
        { id: "only_send_client", label: this.translate("client_order.only_send_client")}
      ]
    },
    orders_list(){
      let orders_list = [...this.client_orders_list];
      return orders_list.sort(this.compareNumbers);
    },
    status_list(){
      return this.$store.getters.getClientOrdersInfo.statuses.map((entry) => {
        return {id: entry.id, label: this.translate("client_order.statuses." + entry.title)}
      })
    },
    type_list(){
      return this.$store.getters.getClientOrdersInfo.types.map((entry) => {
        return {id: entry.id, label: this.translate("client_order.type_orders." + entry.title)}
      })
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    specification_list(){
      return [...this.$store.getters.getClientOrderSpecs.list].sort((a, b) => b.id - a.id).map((specification) => {
        return {
          id: specification.id,
          label: specification.name || specification.title
        }
      })
    },
    article_list(){
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return { id: sku.id, label: sku.name }
      })
    },
    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {label: user.name, id: user.id}
      })
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'production_section' && this.$route.params.production_section) {
          let string = '?'
          for (let key in this.filter) {
            if (key === 'date'){
              if(this.filter[key][0] !== null && this.filter[key][1]){
                string += '&' + key + '=' + this.filter[key]
              }
            } else if (key === 'device_skus' || key === 'client_ids') {
              if (this.filter[key].length > 0) {
                string += '&' + key + '=' + this.filter[key]
              }
            } else {
              if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                string += '&' + key + '=' + this.filter[key]
              }
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },

    additional_params(newValue, oldValue) {
      let value = [...newValue]
      const addedItem = newValue.find(item => !oldValue.includes(item))

      if (addedItem === 'not_send_client') {
        value = newValue.filter(item => item !== 'only_send_client')
      }

      if (addedItem === 'only_send_client') {
        value = newValue.filter(item => item !== 'not_send_client')
      }

      if (value.length !== newValue.length) {
        this.additional_params = value
        return
      }

      this.params_list.forEach(param => {
        this.filter[param.id] = value.indexOf(param.id) > -1 ? 1 : null
      })

      window.localStorage.setItem('client_order_additional_params', JSON.stringify(value))
    }
  },
  created() {
    this.additional_params = window.localStorage.getItem('client_order_additional_params') ? JSON.parse(window.localStorage.getItem('client_order_additional_params')) : []
    this.check_query()
  },

  activated() {
    this.additional_params = window.localStorage.getItem('client_order_additional_params') ? JSON.parse(window.localStorage.getItem('client_order_additional_params')) : []
    this.check_query()
  },

  deactivated() {
    this.$modal.hide('client_order_modal')

    this.filter = {
      type: null,
      status: null,
      client_ids: [],
      date: [],
      customer_user_id: null,
      search: "",
      not_send_client: null,
      client_order_spec_item_id: null,
      client_order_spec_id: null
    }
  },

  methods: {
    formation_orders() {
      let t = this.$createElement(FormationOrders, {
        props: {},
        on: {
          update: () => {
            this.load_client_orders()
            this.$modal.hide('formation_orders_modal')
          },
          close: () => {
            this.$modal.hide('formation_orders_modal')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'formation_orders_modal'
      })
    },
    update_checked(order){
      let order_key = this.client_orders_list.indexOf(order)
      this.client_orders_list[order_key].checked = true
    },
    checkAll(){
      this.client_orders_list.forEach(item => {
        item.checked = this.checkall
      })
    },
    reset_filter(){
      this.filter = {
        type: null,
        status: null,
        client_ids: [],
        date: [],
        customer_user_id: null,
        search: "",
        not_send_client: null,
        only_send_client: null,
        client_order_spec_item_id: null,
        client_order_spec_id: null
      }
      this.additional_params = []

      this.load_client_orders()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_client_orders, 300)
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'type':
            case 'status':
            case 'customer_user_id':
            case 'search':
            case 'client_order_spec_item_id':
            case 'client_order_spec_id':
              this.filter[key] = this.$route.query[key]
              break;
            case 'date':
            case 'device_skus':
            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',')
              break;

            case 'not_send_client':
            case 'only_send_client':
              this.filter[key] = Number(this.$route.query[key])
              if(!(this.additional_params.indexOf(key) > -1)){
                this.additional_params.push(key)
              }
              break;
          }
        }
      }
      this.change_input()
    },
    load_client_orders(){
      let filter = {};
      Object.keys(this.filter).forEach((item) => {
        if (item === "date"){
          const date = this.filter[item]
          if (date.length > 0 && date[0] !== null && date[1] !== null){
            filter.date_start = date[0];
            filter.date_end = date[1];
          }
        } else if (item === "device_skus" || item === "client_ids") {
          if (this.filter[item].length > 0){
            filter[item] = this.filter[item]
          }
        } else {
          if (this.filter[item] !== "" && this.filter[item] !== null && this.filter[item] !== undefined){
            filter[item] = this.filter[item]
          }
        }
      })

      this.$http.v1.getClientOrdersList(filter, (response) => {
        if (response.data){
          this.client_orders_list = response.data.data.map( item => {
            return { ...item, checked: false}
          })
          this.summary = response.data.summary
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    close_modal () {
      if (!this.check_link) {
        history.pushState(null, null, this.window_info)
      }else{
        window.location.href = window.location.href.replace('/' + this.$route.params.user_id, '')
      }
    },
    add_client_order() {
      let t = this.$createElement(AddClientOrder, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('client_order_modal')
            this.check_link = true
          },
          update: () => {
            this.$store.dispatch('clientsListUpdate')
            this.load_client_orders()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'client_order_modal'
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.client_orders_list{
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 750px) {
    overflow-y: scroll;
  }

  .main_filters{
    top: 20px;
  }

  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    height: 100%;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    @media (max-width: 750px) {
      flex-direction: column;
    }
    .buttons{
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      @media (max-width: 750px) {
        width: 100%;
      }
      .btn{
        margin-bottom: 10px;
        padding: 0 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      @media (max-width: 750px) {
        flex: inherit;
        width: 100%;
        margin-bottom: 10px;
      }
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
      .select{
        margin-bottom: 10px;
        width: 100%;
        &:last-child{
          margin-bottom: 0;
        }
      }
      @media (max-width: 750px) {
        margin-right: 0;
      }
    }
  }

  .response_table{
    flex: 10;
    padding-left: 0;
    padding-right: 0;

    table{
      height: calc(100% - 40px);
      overflow-x: hidden;
      th{
        font-size: 12px;
      }
      tbody{
        .online{
          color: #15ab00;
        }
        span{
          font-size: 22px;
        }
      }
    }
    .level{
      display: inline-block;
      width: 20px;
      height: 100%;
    }
    .has_child{
      background-color: #eee;
      font-weight: bold;
    }
    .name{
      text-align: center;
    }
    .inn{
      text-align: left;
    }
  }
}

@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
    .search_user{
      width: 80%;
    }
  }

}
</style>
